<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="150px" >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.docNo')">
                <el-input v-model="requestNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.crReason')">
                <el-select v-model="crReason" :placeholder="$t('msg.pleaseSelect')" clearable >
                  <el-option v-for="item in crReasonOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>            
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.demandDate')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.showPersonalTasks')" >
                <el-switch v-model="showPersonalTasks"></el-switch>
              </el-form-item>
            </el-col>   
          </el-row> 
   
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row>  
          <Table ref="table1" :tableData="tableData" :linkAction="linkAction" @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTableWithRemoteSort'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindCNCByCondition, apiFindSysAttrValueByCategory } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

  
export default {
  name: 'searchCNC',
  data() {    
    return {       
      sdate: '',
      edate: '',
      requestNo: '',
      crReason: '',
      crReasonOpts:[],
      showPersonalTasks:false,
      sortColumn:'',
      sortType:'',
      tableData: {
        columns: [
          { field: "requestNo", title: this.$i18n.t('field.docNo'), width: 130, link:true, align:'center', width:180 },         
          { field: "status", title: this.$i18n.t('field.status') , width: 130   },
          { field: "applyDate", title: this.$i18n.t('field.demandDate') , width: 150   },
          { field: "applyAccount", title: this.$i18n.t('field.requestAccount'), width: 160 },
          { field: "assignee", title: this.$i18n.t('field.taskOwner'), width: 160 },
          { field: "crNo", title: this.$i18n.t('field.crRequestNo'), width: 150 },
          { field: "reason", title: this.$i18n.t('field.crReason'), width: 180 },       
          { field: "description", title: this.$i18n.t('field.description'), width: 180 },       
          { field: "modelName", title: 'Model Name', width: 250 },
          { field: "target", title: 'Target', width: 250 },
          { field: "pm", title: 'PM',width: 180 },
          { field: "ecrNo", title: 'ECR No',  width: 180 },
          { field: "ecnNo", title: 'ECN No', width: 180 },
          { field: "updateTo", title: this.$i18n.t('field.updatedTo'), width: 300 },
          { field: "isCritical", title: this.$i18n.t('field.criticalUpd'), align:'center', width: 150 },
          { field: "mailTo", title: this.$i18n.t('field.informCustomer'), width: 300 },
          { field: "mailCc", title: this.$i18n.t('field.informPM'), width: 250 }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'custTable',
        exportName: this.$i18n.t('menu.searchCR')
      }    
    };
  }, 
  components: {
    Breadcrumb,
    Table
  },
  mounted() {  
    apiFindSysAttrValueByCategory({ headers: authHeader(), condition: 'CR_REASON'}).then((response) => { 
      this.crReasonOpts = [];
      response.data.forEach((item, index) => {   
        this.crReasonOpts.push({ value: item.key, label: item.key });
      });
    }).catch((err) => {
      console.log(err);
    });

    this.findData()
   
  },
  methods: {
    findData(){      
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
       if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      }
      apiFindCNCByCondition({ headers: authHeader(), condition: this.requestNo, reason: this.crReason, sdate : sdate, edate : edate, showPersonalTasks:this.showPersonalTasks,
          sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 
          this.tableData.data = response.data;  
          this.tableData.originalTableData =  this.tableData.data;  
          this.$refs.table1.$refs.filterTable.doLayout();

      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },   
    linkAction(row, index){    
      // this.$router.push("/createCNC/" + row.id);
      const { href } = this.$router.resolve("/createCNC/" + row.id );
      window.open(href, '_blank');
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      this.findData()
    } 
  }
};
</script>
